export class AndFilter {
  private list : boolean[];
	private filterName : string;

	constructor(name : string) {
		this.filterName = name;
    this.list = [];
	}

	public addElement(value : boolean) : void {
		this.list.push(value);
	}

	public getFilterName() : string {
		return this.filterName;
	}

	public getOrResult() : boolean {
		if(this.list.includes(true)) {
			return true;
		}else {
			return false;
		}
	}
}
